import { forwardRef } from 'react';
import clsx from 'clsx';

export const Input = forwardRef(function Input(
  { label, error, hint, className, id, type = 'text', ...rest },
  ref
) {
  const inputId = id || rest.name || crypto.randomUUID();
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-ink">
          {label}
        </label>
      )}
      <input
        id={inputId}
        ref={ref}
        type={type}
        className={clsx(
          'h-9 rounded-md border bg-surface-elevated px-3 text-sm text-ink placeholder:text-ink-faint',
          'transition-colors',
          error ? 'border-danger focus:border-danger' : 'border-border-strong focus:border-ink',
          'focus:outline-none focus:ring-2 focus:ring-ink/10',
          className
        )}
        {...rest}
      />
      {error ? (
        <span className="text-xs text-danger">{error}</span>
      ) : hint ? (
        <span className="text-xs text-ink-muted">{hint}</span>
      ) : null}
    </div>
  );
});
